<template>
  <a :href="link" class="editor-preview is--small" v-if="!!previewStat">
    <p v-if="previewStat ==='pending'" :style="{margin: 'auto'}">Vorschau wird geladen</p>
    <div v-if="previewStat === 'show' && showImage()" class="preview__image"
         :style="{backgroundImage: getPreviewImage()}">
      <div class="preview-image-change" v-if="previewShowImageSlide">
        <button type="button" @click="prevImage">&lsaquo;</button>
        <button type="button" @click="nextImage">&rsaquo;</button>
      </div>
    </div>
    <div v-if="previewStat === 'show' && showVideo() && showImage() === false"  class="preview__image is--video">
      <video width="100%" muted>
        <source :src="previewData.video">
        Your browser does not support the video tag.
      </video>
    </div>
    <div v-if="previewStat === 'show'" class="preview__text">
      <div class="title">{{ previewData.title }}</div>
      <div class="content">{{ turncateString(previewData.description) }}</div>

    </div>
    <button v-if="previewStat === 'show'" class="remove" @click="previewRemove">
      <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348"
           width="512" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/>
      </svg>
    </button>
  </a>
</template>

<script>
export default {
  name: 'LinkPreviewSmall',
  props: {
    previewData: Object,
    previewStat: String,
    previewLink: String,
    previewShowSlide: Boolean,
    previewRemove: Function
  },
  data () {
    return {
      link: this.previewLink,
      previewImage: '',
      previewImagePos: 0,
      previewShowImageSlide: this.previewShowSlide
    };
  },
  methods: {

    nextImage () {
      let images = this.previewData.images;
      let keys = Object.keys(images);
      if ((this.previewImagePos + 1) < keys.length) {
        this.previewImagePos++;
        this.previewImage = images[keys[this.previewImagePos]];
      }
    },
    prevImage () {
      let images = this.previewData.images;
      let keys = Object.keys(images);
      if (this.previewImagePos > 0) {
        this.previewImagePos--;
        this.previewImage = images[keys[this.previewImagePos]];
      }
    },
    turncateString (text) {
      if (text.length > 300) {
        // return text.substr(0, 280) + '...';
        return text;
      } else {
        return text;
      }
    },
    getPreviewImage () {
      let img = '';
      if (this.previewData.cover) {
        img = this.previewData.cover;
      } else if (typeof this.previewData.images === 'object') {
        let keys = Object.keys(this.previewData.images);
        img = this.previewData.images[keys[this.previewImagePos]];
      }
      this.previewImage = img;
      if (img) {
        return 'url(' + img + ')';
        // return img;
      } else {
        return '';
      }
    },

    showImage () {
      let img = '';
      if (this.previewData.cover) {
        img = this.previewData.cover;
        this.previewShowImageSlide = false;
      } else if (typeof this.previewData.images === 'object') {
        let keys = Object.keys(this.previewData.images);
        img = this.previewData.images[keys[this.previewImagePos]];
        this.previewShowImageSlide = keys.length > 1;
      }
      return !!img;
    },
    showVideo () {
      return !!this.previewData.video;
    }

  },
  computed: {

    extractHost () {
      let links = this.previewLink.replace('https://', '').replace('http://', '').split('/');
      let link = '';
      if (links.length > 0) {
        link = links[0];
      }
      return link;
    }

  }
};
</script>

<style lang="scss">
.editor-preview.is--small {
  border: none;
  color: #343434;

  .preview__image {
    width: 65px;
    height: 65px;
    background-size: cover;
  }

  .preview__text {
    width: calc(100% - 65px);
    padding: 5px;
    border: none;

    .content {
      font-size: 11px;
      line-height: 1.2;
      height: 25px;
    }
  }
}
</style>
